import { apiSlice } from "../../app/api/apiSlice";

export const bankingApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBankingAccounts: builder.query({
      query: () => "/banking",
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: "BankingAccount", id: _id })),
              { type: "BankingAccount", id: "LIST" },
            ]
          : [{ type: "BankingAccount", id: "LIST" }],
    }),
    createBankingAccount: builder.mutation({
      query: (newAccount) => ({
        url: "/banking",
        method: "POST",
        body: newAccount,
      }),
      invalidatesTags: [{ type: "BankingAccount", id: "LIST" }],
    }),
    updateBankingAccount: builder.mutation({
      query: (updatedAccount) => ({
        url: "/banking",
        method: "PATCH",
        body: updatedAccount,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "BankingAccount", id: arg._id },
        { type: "BankingAccount", id: "LIST" },
      ],
    }),
    deleteBankingAccount: builder.mutation({
      query: (data) => ({
        url: "/banking",
        method: "DELETE",
        body: data,
      }),
      invalidatesTags: [{ type: "BankingAccount", id: "LIST" }],
    }),
    // NEW: Mark an account as main
    markAccountAsMain: builder.mutation({
      query: (arg) => ({
        url: "/banking/main",
        method: "PATCH",
        body: { id: arg }, // expecting just an ID
      }),
      invalidatesTags: [{ type: "BankingAccount", id: "LIST" }],
    }),
  }),
});

export const {
  useGetBankingAccountsQuery,
  useCreateBankingAccountMutation,
  useUpdateBankingAccountMutation,
  useDeleteBankingAccountMutation,
  useMarkAccountAsMainMutation,
} = bankingApiSlice;
